import { render, staticRenderFns } from "./areaAdd.vue?vue&type=template&id=76b55d7c&scoped=true&"
import script from "./areaAdd.vue?vue&type=script&lang=js&"
export * from "./areaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b55d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b55d7c')) {
      api.createRecord('76b55d7c', component.options)
    } else {
      api.reload('76b55d7c', component.options)
    }
    module.hot.accept("./areaAdd.vue?vue&type=template&id=76b55d7c&scoped=true&", function () {
      api.rerender('76b55d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaApply/areaAdd.vue"
export default component.exports